import { ImgProps } from "assets/images/types";

export default function ImgDiaDasMaesMmbbFooter1(props: ImgProps) {
	const { height = 295, width = 295 } = props;
	return (
		<img
			src="/assets/images/cases/dia-das-maes-mmbb/dia-das-maes-mmbb-footer-1.webp"
			alt="Dê um banho delicado e relaxante."
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
